export default "__VITE_ASSET__78e8ad35__"